"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _FolderTreeContainer = _interopRequireDefault(require("../containers/FolderTreeContainer"));

var _FoldersAndFiles = require("../utils/FoldersAndFiles");

var SelectFolderPopover = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SelectFolderPopover, _Component);

  function SelectFolderPopover(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SelectFolderPopover);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SelectFolderPopover).call(this, props));
    _this.state = {
      open: false,
      selectedFolder: props.folder
    };
    _this.handleSelect = _this.handleSelect.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSave = _this.handleSave.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleOpenChange = _this.handleOpenChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClickChangeFolder = _this.handleClickChangeFolder.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(SelectFolderPopover, [{
    key: "handleSelect",
    value: function handleSelect(folder) {
      this.setState({
        selectedFolder: folder
      });
    }
  }, {
    key: "handleSave",
    value: function handleSave() {
      var onChangeFolder = this.props.onChangeFolder;
      var selectedFolder = this.state.selectedFolder;
      onChangeFolder(selectedFolder);
      this.setState({
        open: false
      });
    }
  }, {
    key: "handleOpenChange",
    value: function handleOpenChange() {
      this.setState({
        open: !this.state.open
      });
    }
  }, {
    key: "handleClickChangeFolder",
    value: function handleClickChangeFolder() {
      var onTrackInteraction = this.props.onTrackInteraction;

      if (onTrackInteraction) {
        onTrackInteraction('Browse Shutterstock', 'clicked-change-folder');
      }

      this.setState({
        open: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          open = _this$state.open,
          selectedFolder = _this$state.selectedFolder;
      return _react.default.createElement(_UIPopover.default, {
        open: open,
        closeOnOutsideClick: true,
        onOpenChange: this.handleOpenChange,
        placement: "top right",
        content: {
          header: _react.default.createElement("h4", null, _I18n.default.text('FileManagerCore.selectFolder')),
          body: _react.default.createElement("div", {
            className: "select-folder-popover__folder-tree"
          }, _react.default.createElement(_FolderTreeContainer.default, {
            selectedFolder: selectedFolder || (0, _FoldersAndFiles.getHomeFolder)(),
            onSelect: this.handleSelect
          })),
          footer: _react.default.createElement("div", null, _react.default.createElement(_UIButton.default, {
            use: "tertiary",
            size: "small",
            disabled: !selectedFolder,
            onClick: this.handleSave
          }, _I18n.default.text('FileManagerCore.actions.save')))
        }
      }, _react.default.createElement(_UILink.default, {
        className: "m-left-4",
        use: "on-dark",
        onClick: this.handleClickChangeFolder
      }, _I18n.default.text('FileManagerCore.actions.changeFolder')));
    }
  }]);
  return SelectFolderPopover;
}(_react.Component);

exports.default = SelectFolderPopover;
SelectFolderPopover.propTypes = {
  folder: _propTypes.default.instanceOf(_immutable.default.Map),
  onChangeFolder: _propTypes.default.func.isRequired,
  onTrackInteraction: _propTypes.default.func
};
module.exports = exports.default;